import { initializeVariablePageSize } from "../Utilities/paging";
import { isNullOrWhiteSpace } from "../Utilities/string";

// A more sane configuration for oob swap - without it the load more button oob swap does not work
htmx.config.allowNestedOobSwaps = false;

document
  .querySelectorAll<HTMLElement>("[data-load-more-button]")
  .forEach(loadMoreButton => {
    const dynamicPageSize = loadMoreButton.dataset.dynamicPageSize === "true";
    const formId = loadMoreButton.dataset.formId;
    const loadAll = loadMoreButton.dataset.loadAll === "true";

    let queryInputName = loadMoreButton.dataset.queryInputName;

    if (isNullOrWhiteSpace(queryInputName)) {
      queryInputName = "query";
    }

    const form = !isNullOrWhiteSpace(formId)
      ? (document.getElementById(formId) as HTMLFormElement | null)
      : undefined;

    if (!form) {
      throw "Load more button form missing";
    }

    // Override a couple of form parameters when clicking the load more button
    htmx.on(form, "htmx:configRequest", (e: Event) => {
      const event = e as ConfigRequestEvent;

      const triggeringElement = event.detail.elt;

      if (triggeringElement.dataset.loadMoreButton !== undefined) {
        if (loadAll) {
          event.detail.parameters.loadAll = true;
        } else {
          event.detail.parameters.page = triggeringElement.dataset.pageNumber;
        }

        const query = triggeringElement.dataset[queryInputName];

        if (query === undefined) {
          delete event.detail.parameters[queryInputName];
        } else {
          event.detail.parameters[queryInputName] = query;
        }
      }
    });

    if (dynamicPageSize) {
      const pageSizeXs = !isNullOrWhiteSpace(loadMoreButton.dataset.pageSizeXs)
        ? parseInt(loadMoreButton.dataset.pageSizeXs)
        : 4;

      const pageSizeSm = !isNullOrWhiteSpace(loadMoreButton.dataset.pageSizeSm)
        ? parseInt(loadMoreButton.dataset.pageSizeSm)
        : 4;

      const pageSizeMd = !isNullOrWhiteSpace(loadMoreButton.dataset.pageSizeMd)
        ? parseInt(loadMoreButton.dataset.pageSizeMd)
        : 6;

      const pageSizeLg = !isNullOrWhiteSpace(loadMoreButton.dataset.pageSizeLg)
        ? parseInt(loadMoreButton.dataset.pageSizeLg)
        : 6;

      const pageSizeXl = !isNullOrWhiteSpace(loadMoreButton.dataset.pageSizeXl)
        ? parseInt(loadMoreButton.dataset.pageSizeXl)
        : 8;

      const serverPageSize = !isNullOrWhiteSpace(loadMoreButton.dataset.serverPageSize)
        ? parseInt(loadMoreButton.dataset.serverPageSize)
        : 8;

      const searchResultsListSelector = loadMoreButton.dataset.searchResultsListSelector;

      if (isNullOrWhiteSpace(searchResultsListSelector)) {
        throw "Load more button search results list selector missing";
      }

      initializeVariablePageSize({
        form,
        loadAllOnClick: loadAll,
        loadMoreButtonId: loadMoreButton.id,
        pageSizeXs,
        pageSizeSm,
        pageSizeMd,
        pageSizeLg,
        pageSizeXl,
        searchResultsSelector: searchResultsListSelector,
        serverPageSize
      });
    }
  });
